/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NotificationAppIcon64Regular = forwardRef('NotificationAppIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M49.5 3C43.149 3 38 8.149 38 14.5S43.149 26 49.5 26 61 20.851 61 14.5 55.851 3 49.5 3ZM41 14.5a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0Z" }),
        React.createElement("path", { d: "M10 17.5a7.5 7.5 0 0 1 7.5-7.5H32a1.5 1.5 0 0 0 0-3H17.5C11.701 7 7 11.701 7 17.5v29C7 52.299 11.701 57 17.5 57h29C52.299 57 57 52.299 57 46.5V32a1.5 1.5 0 0 0-3 0v14.5a7.5 7.5 0 0 1-7.5 7.5h-29a7.5 7.5 0 0 1-7.5-7.5v-29Z" })));
});
